import { conformToMask } from 'text-mask-core';

import { countryCode } from 'common/src/app/data/enum/Countries';

import { PHONE_NUMBER_MASK } from '../../data/regexPatterns';

const PHONE_CHAR = /[\d+()\-\s]/;
// DEFAULT_MASK is used by all countries other than:
// - GB
// - US
// - CY
const DEFAULT_MASK = new Array(20).fill(PHONE_CHAR);

const phoneNumberFormatter = (value, mask = DEFAULT_MASK, options = { guide: false }) =>
  conformToMask(value, mask, options).conformedValue;

export const phoneNumberByCountryFormatter = (value = '', country = countryCode.GB) => {
  // If there is no value, then return an empty string
  if (!value) return '';

  return phoneNumberFormatter(value, PHONE_NUMBER_MASK[country] || undefined);
};
